import { render, staticRenderFns } from "./FooterAdmin.vue?vue&type=template&id=2ef7da8e&"
import script from "./FooterAdmin.vue?vue&type=script&lang=js&"
export * from "./FooterAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
installComponents(component, {VCol,VFooter})
